module.exports = __webpack_public_path__ + "img/Frame 427325370.31b6130d.svg";